module.exports = __webpack_public_path__ + "h5/img/global_rb.230021f3.png";